import type { ComponentType } from '@grafikr/components';
import ShopSwitch from 'utils/shop-switch';

const component: ComponentType = (node) => {
  const data = JSON.parse(node.querySelector('script').innerHTML);
  const { sites } = data;
  if (!sites.length) return;
  const shopSwitch = ShopSwitch(sites, node);

  const dismiss = node.querySelectorAll('[data-dismiss]');
  const switchToggles = document.querySelectorAll('[data-shop-switch]');
  const overlay = document.querySelector('.overlay');

  if (window.location.search.includes('?geo')) {
    localStorage.setItem('geo:dismissed', 'true');
  }

  dismiss.forEach((button) => {
    button.addEventListener('click', () => {
      shopSwitch.close();
    });
  });

  if (overlay) {
    overlay.addEventListener('click', () => {
      shopSwitch.close();
    });
  }

  switchToggles.forEach((toggle: HTMLElement) => {
    const flag = `<img src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="
    data-src="${shopSwitch.currentShop?.icon}"
    class="lazyload h-4 w-auto"
    alt="${shopSwitch.currentShop?.name} icon">`

    toggle.innerHTML = `${toggle.dataset.hideFlag ? '' : flag}
                     <span class="mx-2">${shopSwitch.currentShop?.name}</span>
                     <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 25 24"><path stroke="#000" stroke-linejoin="round" d="m6.667 9 6 6 6-6"/></svg>`;

    toggle.addEventListener('click', () => {
      shopSwitch.open();
    });
  });
};

export default component;
